import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaLinkedin, FaYoutube } from 'react-icons/fa';
import logo from '../../assets/images/main_logo_icon.svg';
import { handleCall, openGoogleMap, sendMail } from '../../utils/HelperFunctions';
import { ProductsService } from '../../services/ProductsService';

const Footer: React.FC = () => {
  const [manichand2G_URL, setManichand2G_URL] = useState<string>('home');
  const [manichand_4_Gram_URL, setManichand_4_Gram_URL] = useState<string>('home');

  useEffect(() => {
    getProductsList();
  }, []);

  async function getProductsList() {
    try {
      const resp = await ProductsService.List();
      if (resp && resp.message && resp.message.success == 200) {
        const apiData = resp.message?.data;
        const products = apiData ? apiData.product_list : [];
        if (products && products.length > 0) {
          setManichand2G_URL(`/product/details/${products[0]?.item_code}`);
          setManichand_4_Gram_URL(`/product/details/${products[1]?.item_code}`);
        }
      }
    } catch (error) {
      // console.log(error);
    }
  }

  return (
    <footer className='bg-[#F8F8F8] text-black pt-5 sm:pt-5 md:pt-10 lg:pt-10 pb-6'>
      {/* Main Footer Section &  Logo and Social   lg:grid-cols-[1fr_1fr_2fr_2fr] */}
      <div className='max-w-[1200px] mx-auto px-6 sm:px-6 md:px-4 lg:px-1 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-[1.7fr_1.3fr_2fr_3fr] gap-y-4'>
        <div className='flex flex-col items-center mb:items-center lg:items-center sm:items-start text-center sm:text-left'>
          <div className='flex flex-col items-center mb:items-center lg:items-center mt-0 sm:mt-0 mb:mt-16 lg:mt-16 '>
            <img src={logo} alt='Namasteji Logo' className='w-[12rem] h-[5Xrem] object-contain -mb-1' />
            {/* <h2 className='text-[#4A2D1A] font-bold text-[30px] sm:text-[30px] md:text-[32px] lg:text-[32px]'>
              Manikchand
            </h2> */}
          </div>
        </div>

        {/* Menu */}
        <div className='mb:text-start lg:text-start xl:text-start sm:text-left'>
          <h4 className='text-xl sm:text-2xl font-bold md:mb-5 sm:mb-2 lg:mb-5 border-l-4 border-[#A21D21] pl-3 text-[#4A2D1A]'>
            Menu
          </h4>
          <ul className='md:space-y-2 lg:space-y-2 sm:space-y-1  ml-[5%] sm:ml-[5%] md:ml-[0%] lg:ml-[0%]'>
            {[
              { name: 'HOME', path: '/' },
              { name: 'ABOUT US', path: '/about' },
              { name: 'BECOME PARTNER', path: '/partner' },
              { name: 'CONTACT US', path: '/contact' },
              { name: 'FAQ', path: '/faq' },
            ].map((item, idx) => (
              <li key={idx}>
                <Link
                  to={item.path}
                  className='font-poppins text-sm sm:text-sm md:text-lg lg:text-lg hover:text-[#7C0000] transition-colors'
                >
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Our Products */}
        <div className='mb:text-start lg:text-start xl:text-start sm:text-left'>
          <h4 className='text-xl sm:text-2xl font-bold md:mb-6 lg:mb-6 sm:mb-4 border-l-4 border-[#A21D21] pl-3 text-[#4A2D1A]'>
            Our Products
          </h4>
          <ul className='md:space-y-2 sm:space-y-3 ml-[5%] sm:ml-[5%] md:ml-[0%] lg:ml-[0%]'>
            <li>
              <Link
                to={manichand2G_URL}
                state={{ scrollTo: 'target-section-pan-masala' }}
                className='hover:text-[#7C0000] font-poppins text-sm sm:text-sm md:text-lg lg:text-lg transition-colors'
              >
                MANIKCHAND PAN MASALA 2 GRAM
              </Link>
            </li>
            {/* <li>
              <Link
                to={manichand_4_Gram_URL}
                state={{ scrollTo: 'target-section-pan-masala' }}
                className='hover:text-[#7C0000] font-poppins text-sm sm:text-sm md:text-lg lg:text-lg transition-colors'
              >
                MANIKCHAND PAN MASALA 4 GRAM
              </Link>
            </li> */}
          </ul>
        </div>

        {/* Address & Contact */}
        <div className='flex flex-col space-y-6 mb:text-start lg:text-start xl:text-start sm:text-left'>
          <div>
            <h4 className='text-xl sm:text-2xl font-bold md:mb-5 lg:mb-5 sm:mb-3  border-l-4 border-[#A21D21] pl-3 text-[#4A2D1A]'>
              Manufacturing Unit & Warehouse
            </h4>
            <p
              className='font-poppins text-sm sm:text-sm md:text-lg lg:text-lg leading-relaxed ml-[5%] sm:ml-[5%] md:ml-[0%] lg:ml-[0%] cursor-pointer hover:text-[#7C0000]'
              onClick={openGoogleMap}
            >
              523, Near Krishna Hotel, For Godown,
              <br />
              Kanera, Mehemdabad,
              <br />
              Kheda - 387130,
              <br />
              Gujarat
            </p>
          </div>
          <div>
            <h4 className='text-xl sm:text-2xl font-bold md:mb-5 lg:mb-5 sm:mb-3 border-l-4 border-[#A21D21] pl-3 text-[#4A2D1A]'>
              Contact
            </h4>
            <p
              className='font-poppins text-sm sm:text-sm md:text-lg lg:text-lg ml-[5%] sm:ml-[5%] md:ml-[0%] lg:ml-[0%] cursor-pointer hover:text-[#7C0000]'
              onClick={sendMail}
            >
              info@globalmanikchand.in
            </p>
            <p
              className='font-poppins text-sm sm:text-sm md:text-lg lg:text-lg mt-1 ml-[5%] sm:ml-[5%] md:ml-[0%] lg:ml-[0%]  cursor-pointer hover:text-[#7C0000]'
              onClick={handleCall}
            >
              +91 91063-91065
            </p>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className='sm:mt-5 md:mt-10 lg:mt-10 pt-8 md:pt-10 lg:pt-10'>
        <div className='max-w-[1200px] mx-auto flex flex-col sm:flex-row items-center justify-between md:space-x-10 lg:space-x-10 sm:space-x-1 md:px-12 text-xs sm:text-sm text-center sm:text-left '>
          <p className='mb-3 sm:mb-0 select-none font-poppins'>
            Copyright @2025 Namasteji Manikchand . All Rights Reserved
          </p>
          <div className='flex flex-wrap justify-center sm:justify-start gap-x-3 sm:gap-x-3 md:gap-x-6 lg:md:gap-x-6 gap-y-2'>
            <Link to='privacy-policy' className='hover:text-[#7C0000] font-poppins'>
              Privacy Policy
            </Link>
            <Link to='app-policy' className='hover:text-[#7C0000] font-poppins'>
              App Privacy Policy
            </Link>
            <Link to='terms-conditions' className='hover:text-[#7C0000] font-poppins'>
              Terms & Conditions
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
